import { useOnboarding } from '@/contexts/OnboardingContext';
import { Navigate } from 'react-router-dom';
import OnboardingFlow from './OnboardingFlow';

const OnboardingRouteGuard = () => {
  const { status, isLoading } = useOnboarding();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[#1a2236] flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-20 w-20 border-b-4 border-yellow-400 mx-auto mb-6"></div>
          <h2 className="text-2xl font-bold text-yellow-400 mb-2">Checking your onboarding status…</h2>
          <p className="text-lg text-white">Please wait while we verify your account.</p>
        </div>
      </div>
    );
  }

  if (status === 'completed') {
    return <Navigate to="/dashboard" replace />;
  }

  return <OnboardingFlow />;
};

export default OnboardingRouteGuard; 